// Copyright 2022 Huawei Cloud Computing Technology Co., Ltd.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

class NoDebuger {
    static protect() {
        if (!this.isInvade()) {
            this.listen();
        } else {
            this.kickit();
        }
    }

    static kickit() {
        while (this.isInvade()) {
            window.location.reload();
        }
    }

    static listen() {
        window.addEventListener('blur', () => {
            setTimeout(() => {
                this.kickit();
            }, 500);
        });
    }

    static isInvade() {
        let last = Date.now();
        return Date.now() - last > 10;
    }
}

export default NoDebuger;
